import { ConnectedRouter } from 'connected-react-router/immutable';
import { createBrowserHistory } from 'history';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastProvider } from 'react-toast-notifications';
import { PersistGate } from 'redux-persist/integration/react';

import '../style/grifin.css';

import App from './routes/App';
import configureStore from './stores/configureStore';

import { ApolloContext } from '~/components/Apollo';

const history = createBrowserHistory();
const { store, persistor } = configureStore({}, history);

export default store;

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <ApolloContext store={store}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </ApolloContext>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

if (module.hot) {
  module.hot.accept(App);
}
